import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { orderMock } from '../../mocks/order.mock';
import { environment } from '../../../environments/environment';

export interface PaymentCardDataPayload {
  numero: string;
  cvv: string;
  vencto_mes: string;
  vencto_ano: string;
  documento_cliente: string;
  nome_cliente: string;
}

export interface PaymentInclusionPayload {
  forma_pagto: 'CC' | 'PIX' | 'BOL';
  valor: number;
  parcela?: string;
  taxa?: number;
  taxa_percentual?: number;
  codigo_cfg?: string;
  codigo_adq?: string;
  adquirente?: string;
  dados_cartao?: PaymentCardDataPayload[];
}

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(
    private readonly http: HttpClient
  ) {}

  private readonly apiBaseUrl = environment.apiBaseUrl;

  getOrderData(recId: string, companyId: string, seq?: string, search?: boolean) {
    return this.http.get<any>(this.buildUrl(environment.endpoints.fullReceiptsDefault), {
      params: {
        IDREC: recId,
        EMPRESA: companyId,
        ...(seq ? { seq } : {}),
        ...(search ? { search: 'true' } : {})
      }
    });

    // return of(orderMock);
  }

  generatePIXQRCode(amount: number) {
    return of('00020126580014br.gov.bcb.pix0136a1b2c3d4-e5f6-7890-abcd-ef1234567890');
  }

  includePayment(recId: string, companyId: string, payload: PaymentInclusionPayload) {
    return this.http.post(this.buildUrl(environment.endpoints.paymentInclusion), payload, {
      observe: 'response',
      params: {
        idrec: recId,
        empresa: companyId
      },
      responseType: 'text'
    });
  }

  private buildUrl(endpoint: string): string {
    return `${this.apiBaseUrl}/${endpoint}`;
  }
}
